<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="file_031"></a><a id="page_13">bug magnets</a></h2><a id="page_13">
<p class="noindent">If you are just learning how to needle felt, start with this project. You’ll have a charming set of magnets and be encouraged to try making other things. I use a very small rare earth magnet in this project. Be sure not to let pets or children play with the ladybug and bumblebee if you choose to use the same kind of magnet because they are so small and can be a choking hazard.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_031.vue?59ff8702